import React, { useState } from "react";
import init from "../firebase";
import { EmailAuthProvider, linkWithCredential } from "firebase/auth";
import { getFirebaseErrorMessage } from "./getFirebaseErrorMessage";
import "bootstrap/dist/css/bootstrap.min.css";

const SetEmailPassword = () => {
  const auth = init.auth;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSetEmailPassword = async () => {
    try {
      const user = auth.currentUser;

      if (!user) {
        alert("User not logged in");
        return;
      }

      setLoading(true);

      const credential = EmailAuthProvider.credential(email, password);
      const result = await linkWithCredential(user, credential);

      console.log("Email & Password set successfully", result.user);
      alert("Email & Password added successfully");

      setEmail("");
      setPassword("");
    } catch (error) {
      const res = getFirebaseErrorMessage(error.code);
      alert(res);
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
                 <div className="card-header text-white bg-primary">
                              Set Email & Password
                            </div>

            <div className="card-body">
                {/* Email */}
              <div className="mb-3">
                <label className="form-label">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Password */}
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              {/* Button */}
              <button
                className="btn btn-primary w-100 d-flex justify-content-center align-items-center"
                onClick={handleSetEmailPassword}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save Email & Password"
                )}
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetEmailPassword;